import { render, staticRenderFns } from "./PageM.vue?vue&type=template&id=69f023fa&scoped=true"
import script from "./PageM.vue?vue&type=script&lang=js"
export * from "./PageM.vue?vue&type=script&lang=js"
import style0 from "./PageM.vue?vue&type=style&index=0&id=69f023fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f023fa",
  null
  
)

export default component.exports